import { Controller } from "@hotwired/stimulus"
import { MeiliSearch } from "meilisearch"

// MeiliSearch autocomplete for plant names with duplicate detection
// Values: field, placeholder, name, plantId, parentId
// Targets: input, duplicates
export default class extends Controller {
  static values = { field: String, placeholder: String, name: String, plantId: Number, parentId: Number }
  static targets = ["input", "duplicates"]

  connect() {
    const env = document.querySelector('meta[name=env]')?.content || 'development'
    const client = new MeiliSearch({ host: location.protocol + '//' + location.host })
    this.index = client.index('Plant_' + env)
  }

  search() {
    const q = this.inputTarget.value

    if (q !== "") {
      const filters = []
      if (this.plantIdValue) filters.push("id != " + this.plantIdValue)
      if (this.parentIdValue) filters.push("parent_id = " + this.parentIdValue)

      this.index.search(q, {
        filters: filters.join(" AND "),
        hitsPerPage: 10
      }).then((result) => {
        this.renderDuplicates(result.hits)
      })
    } else {
      this.renderDuplicates([])
    }
  }

  renderDuplicates(hits) {
    if (hits.length > 0) {
      const links = hits.map(hit => `<a href="${hit.link}">${hit.scientific_name} (${hit.name})</a>`).join(", ")
      this.duplicatesTarget.innerHTML = `<p>Possible duplicates: ${links}</p>`
    } else {
      this.duplicatesTarget.innerHTML = ""
    }
  }
}
